// angular imports
import {
    Component,
    EventEmitter,
    Injector,
    Input,
    OnChanges,
    OnInit,
    Output,
    SimpleChanges,
    ViewChild
} from '@angular/core';

// cc-common imports
import { Utils } from 'cc-common';

// devextreme imports
import { DxDataGridComponent } from 'devextreme-angular';

// component imports
import { WorkOrderBaseComponent } from '../../../_base/work-order-base-component';

// model imports
import { ProjectTaskWorkOrderLinkResultDto } from '../../../_models/project-task-work-order-link-result-dto';

@Component({
    selector: 'app-manage-task-grid',
    templateUrl: './manage-task-grid.component.html',
    styleUrls: ['./manage-task-grid.component.scss']
})
export class ManageTaskGridComponent extends WorkOrderBaseComponent implements OnInit, OnChanges {
    @ViewChild('taskGrid', { static: false }) taskGrid: DxDataGridComponent;

    @Input() workOrderStatus: string;
    @Input() taskGridSource: Array<ProjectTaskWorkOrderLinkResultDto> = [];
    @Input() taskIds: Array<number> = [];
    @Input() communityId: number;

    @Output() onRowSelectionChange = new EventEmitter<any>();

    storageKey: string;
    showLongDescription = false;
    longDescriptionGridIndex: number;

    selectedTask: ProjectTaskWorkOrderLinkResultDto;
    showTaskViewer = false;

    constructor(protected readonly injector: Injector) {
        super(injector);
    }

    ngOnInit() {
        this.storageKey = `${this.workOrderStatus.toUpperCase()}_WORKORDER_TASKS`;
    }

    ngOnChanges(changes: SimpleChanges) {
        if (Utils.notNullOrEmpty(changes.taskGridSource) && changes.taskGridSource.currentValue) {
            this.taskGridSource = changes.taskGridSource.currentValue;
            this.prepareTaskGridSource();
        }
    }

    onGridContentReady(event: any): void {
        if (Utils.notNullOrEmpty(this.taskIds)) {
            event.component.selectRows(this.taskIds, true);
            this.applySorting();
        }
    }

    onGridSelectionChanged(event: any): void {
        const selectedRowKeys = event.selectedRowKeys;
        const deSelectedRowKeys = event.currentDeselectedRowKeys;

        this.onRowSelectionChange.emit({
            selectedRowKeys,
            deSelectedRowKeys
        });
    }

    onDescriptionClick(row: any): void {
        if (Utils.notNullOrEmpty(row)) {
            this.longDescriptionGridIndex = row.rowIndex;
            this.showLongDescription = Utils.isFalse(this.showLongDescription);
        }
    }

    onTaskIdClick(record: ProjectTaskWorkOrderLinkResultDto): void {
        this.selectedTask = record;
        this.showTaskViewer = true;
    }

    onTaskViewerClose(): void {
        this.showTaskViewer = false;
    }

    private prepareTaskGridSource(): void {
        if (Utils.notNullOrEmpty(this.taskIds)) {
            this.taskGridSource.forEach((row) => {
                row.sortId = this.taskIds.find((d) => Utils.equals(d, row.projectTaskId)) ? 1 : 0;
            });
        }
    }

    private applySorting(): void {
        this.taskGridSource.sort((ele1, ele2) => {
            if (ele1.sortId < ele2.sortId) {
                return 1;
            } else if (ele1.sortId > ele2.sortId) {
                return -1;
            } else {
                return 0;
            }
        });
        this.taskGrid.instance.option('dataSource', this.taskGridSource);
        this.taskGrid.instance.refresh(true);
    }
}
